import axios from 'axios';
import platform from "platform";
import { nanoid } from 'nanoid';
import { sha256 } from './sha256';
import { resolveCurrentServer } from './serverConfig';

export const request = async (service, method, data = {}) => {
  checkConnect();

  const storedServer = localStorage.getItem('currentServer');
  const currentServer = resolveCurrentServer(storedServer);
  const apiUrl = currentServer + '/api/';

  let localData = {
    token: localStorage.getItem('token') || '',
    session: localStorage.getItem('session') || '',
    loginHash: localStorage.getItem('loginHash') || '',
    codeHash: localStorage.getItem('codeHash') || '',
    deviceId: localStorage.getItem('deviceId') || genDeviceId(),
  };

  let reqData = { service, method, data };

  if (!data.hasOwnProperty('account')) {
    reqData.data.account = 146923;
  }
    reqData.data.holder = { id: 146923 };
    reqData.data.isSigned = true;
    reqData.data.lang = 'ru_RU';
    reqData.data.token = data.withoutToken ? '' : localData.token;
    reqData.data.session = localData.session;
    reqData.data.timeZoneOffset = Date.now() + '.' + getRandomInt(1000, 9999);
    reqData.data.time = sha256(Date.now() + Math.random());
    reqData.data.signature = calcSignature(reqData, localData.loginHash, localData.codeHash);

    // Попытка получить currentPartner из Redux store динамически, чтобы избежать циклической зависимости при инициализации модулей.
    let currentPartner = null;
    try {
      const mod = await import('../redux/configureStore');
      const store = mod && mod.store;
      const state = store && store.getState && store.getState();
      if (state && state.partner) {
        currentPartner = state.partner.currentPartner;
      }
    } catch (e) {
      // Если импорт или доступ к store не удался — оставляем currentPartner = null
    }

    const appId = currentPartner ? "com.menu4me.dinner.site.partner" : "com.menu4me.dinner.site.sitiyoffice";

    reqData.data.clientInfo = JSON.stringify({
    os: platform.os.family,
		osVersion: platform.os.version,
		model: platform.description,
		brand: platform.product,
    screenWidth: window.screen.width,
    deviceId: localData.deviceId,
    appVersion: "1.21.0",
    appId,
    locale: 'ru_RU',
  });

  try {
    let response = await axios.post(apiUrl, JSON.stringify(reqData));
    if (response.data.result === 0) {
      const error = new Error(response.data.data.message || 'API Error');
      error.service = reqData.service;
      error.method = reqData.method;
      error.code = response.data.resultCode;
      error.result = response.data.result;
      error.errors = response.data.data.errors;
      throw error;
    }
    return response.data;
  } catch (err) {
    console.error(err);
    return err;
  }
};

// Интерцептор для обновления токена
axios.interceptors.response.use(async (response) => {
  if (response.data.resultCode === 's152') {
    let refreshResponse = await request('ClientAuthService', 'RefreshToken', {
      refreshToken: localStorage.getItem('refreshToken'),
    });
    localStorage.setItem('token', refreshResponse.data.token);
    localStorage.setItem('refreshToken', refreshResponse.data.refreshToken);
    
    let newData = JSON.parse(response.config.data);
		newData.data.token = refreshResponse.data.token;
		newData.data.signature = calcSignature(
      newData,
      localStorage.getItem('loginHash') || '',
      localStorage.getItem('codeHash') || '',
    );
    
    response.config.data = JSON.stringify(newData);
    return axios(response.config);
  }
  return response;
});

// Функция генерации уникального ID
const genDeviceId = () => {
  let deviceId = nanoid();
  localStorage.setItem('deviceId', deviceId);
  return deviceId;
};

// Генерация случайного числа в диапазоне
const getRandomInt = (min, max) => {
  return Math.floor(Math.random() * (max - min)) + min;
};

// Подсчёт подписи запроса
const calcSignature = (reqData, loginHash, codeHash) => {
  return sha256(
    reqData.service +
    reqData.method +
    reqData.data.time +
    reqData.data.token +
    loginHash +
    reqData.data.session +
    codeHash
  );
};

// Проверка интернет-соединения
const checkConnect = () => {
  if (!navigator.onLine) {
    console.warn('Отсутствует интернет-соединение');
  }
};
